<div class="order-entry__panel-debug__container">
  <p-tabView
    class="order-entry__panel-debug__tab-view"
    styleClass="bfx-tabview"
    [activeIndex]="control.activeDebugTabIndex"
    (onChange)="onDebugTabActivate($event)"
    #debugTabs
  >
    <p-tabPanel header="Entry Controls">
      <div class="order-entry__panel-debug__pane">
        <p>ACTIVE: {{refId}} [{{control.state.actions_state_name}}]</p>
        <p>
          <button
            pButton
            type="button"
            class="oe__panel-debug__controls__button-lock"
            *ngIf="!control.lock_controls"
            (click)="lockOrderEntry()"
            label="Lock Controls"
          ></button>
          <button
            pButton
            type="button"
            class="oe__panel-debug__controls__button-unlock"
            *ngIf="control.lock_controls"
            (click)="unlockOrderEntry()"
            label="Unlock Controls"
          ></button>
          <button
            pButton
            type="button"
            class="oe__panel-debug__controls__button-config"
            (click)="changeButtonConfig()"
            label="Next State [{{control.state.actions_state_next_name}}]"
          ></button>
        </p>
        <p>
          Client Autocomplete Dataset Mode: {{control.strictClientDatasetMode ? 'STRICT' :
          'LEGACY'}}
          <button
            pButton
            type="button"
            class="oe__panel-debug__controls__button-lock"
            *ngIf="!control.strictClientDatasetMode"
            (click)="toggleClientDatasetMode()"
            label="Activate STRICT mode"
          ></button>
          <button
            pButton
            type="button"
            class="oe__panel-debug__controls__button-unlock"
            *ngIf="control.strictClientDatasetMode"
            (click)="toggleClientDatasetMode()"
            label="Activate LEGACY mode"
          ></button>
          <br />
          <span *ngIf="control.strictClientDatasetMode" style="font-size: 10px">
            In STRICT mode, setting the account value will limit the available clients dataset to
            the ones associated with that account + break accounts.
          </span>
          <span *ngIf="!control.strictClientDatasetMode" style="font-size: 10px">
            In LEGACY mode, no constraints will be imposed on the clients dataset when account is
            selected.
          </span>
        </p>
      </div>
    </p-tabPanel>
    <p-tabPanel header="RefID Listing">
      <div class="oe__panel-debug__pane">
        <p>ROOT: {{rootRefId}}</p>
        <p>ACTIVE: {{refId}} [{{control.state.actions_state_name}}]</p>
        <div>
          RefId LIST ({{refIds?.length}}):
          <div [innerHTML]="refIdsDisplayList"></div>
        </div>
      </div>
    </p-tabPanel>
    <!-- <p-tabPanel header="OBO" >
      <div class="oe__panel-debug__pane" fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start">
        <div class="oe__panel-debug__checkbox__container">
          <span class="ui-float-label">
            <input
              id="debug-obo-user"
              pInputText
              type="text"
              [(ngModel)]="control.oboUser"
              (ngModelChange)="onDebugOBOUserChange()"
            />
            <label for="debug-obo-user">OBO User</label>
          </span>
        </div>
      </div>
    </p-tabPanel>
    -->
    <p-tabPanel header="Logging Controls">
      <div class="oe__panel-debug__pane" fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start">
        <div fxFlex="1 1 50%">
          <div class="oe__panel-debug__checkbox__container">
            <p-checkbox
              class="oe__panel-debug__checkbox"
              [binary]="true"
              label="Extended Logging"
              [(ngModel)]="control.extendedLogging"
              (ngModelChange)="onDebugExtendedLoggingChange()"
            >
            </p-checkbox>
          </div>
          <div class="oe__panel-debug__checkbox__container">
            <p-checkbox
              class="oe__panel-debug__checkbox"
              [binary]="true"
              label="Dump models in logs"
              [(ngModel)]="control.dumpModelsLogging"
              [disabled]="control.dumpModelsLoggingDisabled"
              (ngModelChange)="onDebugDumpModelLoggingChange()"
            >
            </p-checkbox>
          </div>
        </div>
        <div fxFlex="1 1 50%">
          <div class="oe__panel-debug__checkbox__container">
            <p-checkbox
              class="oe__panel-debug__checkbox"
              [binary]="true"
              label="Extended Rate Logging"
              [(ngModel)]="control.extendedLogging_rate"
              (ngModelChange)="onDebugRateExtendedLoggingChange()"
            >
            </p-checkbox>
          </div>
          <div class="oe__panel-debug__checkbox__container">
            <p-checkbox
              class="oe__panel-debug__checkbox"
              [binary]="true"
              label="Dump Rates logs"
              [(ngModel)]="control.dumpModelsLogging_rate"
              [disabled]="control.dumpModelsLoggingDisabled_rate"
              (ngModelChange)="onDebugRateDumpModelLoggingChange()"
            >
            </p-checkbox>
          </div>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Algo Strategy">
      <div class="oe__panel-debug__pane">
        <p>
          <button
            pButton
            type="button"
            class="oe__panel-debug__controls__button-lock"
            (click)="parseATDLXML()"
            label="Parse ATDL-XML"
          ></button>
          <button
            pButton
            type="button"
            class="oe__panel-debug__controls__button-config"
            (click)="validateAlgoPanel()"
            label="Validate Algo IDC"
          ></button>
          <button
            pButton
            type="button"
            class="oe__panel-debug__controls__button-lock"
            (click)="validateAlgoParams()"
            label="Validate Algo Params"
          ></button>
        </p>
        <p>
          Algo Control Validation State: {{control.algo_control_validation_active ? 'ACTIVE' :
          'INACTIVE'}}
        </p>
        <p>
          <button
            pButton
            type="button"
            class="oe__panel-debug__controls__button-unlock"
            *ngIf="!control.algo_control_validation_active"
            (click)="activateControlValidation()"
            label="Activate Control Validation"
          ></button>
          <button
            pButton
            type="button"
            class="oe__panel-debug__controls__button-lock"
            *ngIf="control.algo_control_validation_active"
            (click)="deactivateControlValidation()"
            label="DE-Activate Control Validation"
          ></button>
        </p>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
